<template>
  <div id="step-4-questionnaire">
    <questionnaire-component
      :questionnaire="questionnaire"
    />
  </div>
</template>

<script>
import QuestionnaireComponent from '../components/QuestionnaireComponent.vue';

export default {
  name: 'Step4Questionnaire',
  components: {
    QuestionnaireComponent,
  },
  data() {
    return {
      // TODO find a way to get these fields from a .json file or the drupal site.
      questionnaire: [
        {
          prompt:
            'A good real estate agent can provide valuable services including:',
          type: 'singleChoice',
          options: [
            'Share listings for homes with your search criteria in mind',
            'Provide their expertise to help set your expectations',
            'Help you negotiate your offer',
            'Organize showings for you to tour available homes',
            'All of the above',
          ],
          correctAnswer: 4,
          bottomHeaderTrue: 'That’s right!',
          bottomHeaderFalse: 'Almost.',
          bottomText:
            'A good real estate agent will share listings, provide reasonable expertise, aid in negotiations, and organize showings for available homes.',
        },
        {
          prompt:
            'Commission for real estate agents is usually paid for by the person selling the home',
          type: 'singleChoice',
          options: ['True', 'False'],
          correctAnswer: 0,
          bottomHeaderTrue: 'Excellent job!',
          bottomHeaderFalse: 'Incorrect.',
          bottomText:
            "As the buyer, you typically don't pay the real estate agent; their commission is usually paid for by the seller.",
        },
        {
          prompt: 'What factors should you consider when looking for a home?',
          type: 'multipleChoice',
          options: ['Cost', 'Location', 'Age of home', 'Paint colors of rooms'],
          correctAnswer: [0, 1, 2],
          bottomHeaderTrue: 'Excellent job!',
          bottomHeaderFalse: 'Incorrect.',
          bottomText:
            "Cost, location, and age of home are all important things to consider when looking for a home. Things like paint colors can be changed once you move in and shouldn't be considered a deal breaker.",
        },
      ],
    };
  },
};
</script>

<style>
</style>
